"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExecutionStatusToJSON = exports.ExecutionStatusFromJSONTyped = exports.ExecutionStatusFromJSON = exports.ExecutionStatus = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var ExecutionStatus;
(function (ExecutionStatus) {
    ExecutionStatus["NOTSTARTED"] = "NOT_STARTED";
    ExecutionStatus["INQUEUE"] = "IN_QUEUE";
    ExecutionStatus["INPROCESS"] = "IN_PROCESS";
    ExecutionStatus["POSTPROCESSING"] = "POSTPROCESSING";
    ExecutionStatus["SUSPENDED"] = "SUSPENDED";
    ExecutionStatus["COMPLETED"] = "COMPLETED";
    ExecutionStatus["CANCELLED"] = "CANCELLED";
    ExecutionStatus["FAILED"] = "FAILED";
})(ExecutionStatus = exports.ExecutionStatus || (exports.ExecutionStatus = {}));
function ExecutionStatusFromJSON(json) {
    return ExecutionStatusFromJSONTyped(json, false);
}
exports.ExecutionStatusFromJSON = ExecutionStatusFromJSON;
function ExecutionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ExecutionStatusFromJSONTyped = ExecutionStatusFromJSONTyped;
function ExecutionStatusToJSON(value) {
    return value;
}
exports.ExecutionStatusToJSON = ExecutionStatusToJSON;
